<template>
  <div
    v-if="unit && !noAds && !onlyMasthead && !hideSponsoredAds && !isSponsoredAndHide"
    class="bg-[#f7f8fb] pt-2 pb-6 mt-2 w-full relative overflow-hidden"
    :class="{ 'min-h-[200px]': !unitName, article__oads: unit !== 'icerikSonuBottom' && unit !== 'icerikSonuDikey' }"
  >
    <div class="text-[#7F8083] text-13 font-semibold leading-16 pb-1 u-center" :class="{ 'pb-3': !unitName }">
      {{
        unit === 'icerikSonuBottom' || unit === 'icerikSonuDikey'
          ? $t('news-page.article-bottom-ad-title')
          : unit === 'icerikArasiBottom'
          ? $t('news-page.article-last-ad-title')
          : $t('news-page.article-ad-title')
      }}
      <OIcon icon="chevron-right-grey" class="rotate-90 ml-1.5" />
    </div>
    <AdController
      v-if="unitName"
      :key="unit + device"
      class="w-full flex justify-center article-oads"
      :class="{ 'flex-col': isMobile }"
      :unit="unit"
      v-bind="$attrs"
    />
    <AdController v-else :key="unit + device" :unit="unit" class="w-full flex justify-center article-oads" v-bind="$attrs" />
    <div class="absolute right-1 bottom-1 flex justify-end text-xs text-primary-200">{{ $t('main.ads') }}</div>
  </div>
</template>
<script>
import { defineComponent, computed, inject } from '@nuxtjs/composition-api';
import AdController from '@/modules/ads/components/AdController';
import { useDevice } from '@/composables/useDevice';
import OIcon from '~/modules/common/components/ui/OIcon/OIcon.vue';
export default defineComponent({
  props: {
    entries: {
      type: Array,
    },
    entry: {
      type: Object,
    },
    unitName: {
      type: String,
    },
  },
  components: {
    AdController,
    OIcon,
  },
  setup(props) {
    const adConfig = inject('adConfig');
    const unit = computed(() => {
      if (props.unitName) {
        return props.unitName;
      }
      const index = props.entries.indexOf(props.entry);
      if (index === 0) {
        return 'icerikArasiTop';
      } else if (index === props.entries.length - 1) {
        return 'icerikSonuBottom';
      } else if (index === 5) {
        return 'icerikArasiMiddle1';
      } else if ((index - 15 >= 0 && index % 5 === 0) || index === 10) {
        return 'icerikArasiMiddle2';
      } else {
        return false;
      }
    });
    const noAds = adConfig.value?.decidedMode?.value === 'PremiumUser' || adConfig.value?.decidedMode?.value === 'noAds';
    const onlyMasthead = adConfig.value?.onlyMasthead;
    const hideSponsoredAds = adConfig.value?.decidedMode?.value === 'sponsored' && adConfig.value.sponsoredTag?.type === 'category';
    const isSponsoredAndHide =
      adConfig.value?.decidedMode?.value === 'sponsored' && (unit.value === 'icerikSonuDikey' || unit.value === 'icerikSonuBottom');
    const { isMobile } = useDevice();
    const device = computed(() => (isMobile.value ? 'mobile' : 'desktop'));
    return { unit, noAds, device, hideSponsoredAds, isSponsoredAndHide, onlyMasthead, isMobile };
  },
});
</script>
